import React from 'react';
import styles from '../../ActivityCard.scss';
import cls from 'classnames';

type Item = {
  width?: number | string;
  height?: number | string;
  className?: string;
};

export const SkeletonItem = ({ width = '100%', height = '100%', className }: Item) => {
  return <span className={cls(styles.skeletonItem, className)} style={{ width, height }} />;
};

type Props = {
  className?: string;
};

const Skeleton = ({ className }: Props) => {
  return (
    <div className={cls(styles.ActivityCard, styles.isSkeleton, className)}>
      <div className={styles.image}>
        <SkeletonItem />
      </div>

      <div className={styles.content}>
        <h3 className={styles.title}>
          <SkeletonItem />
        </h3>

        <div className={styles.bottom}>
          <div className={styles.row}>
            <SkeletonItem width={150} height={20} />
            <SkeletonItem width={90} height={20} />
          </div>

          <div className={cls(styles.row, styles.rowIsLast)}>
            <SkeletonItem width={120} height={20} />
            <SkeletonItem width={70} height={20} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
